module.exports = __webpack_public_path__ + "media/img/vca/categories/resilient-c05ceebdac5c2344e3f45a76f088a1fd.png";